var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2b1a08",
    strokeWidth: 2.2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 20 L4 30 L4 34 L24 29 L44 34 L44 30 Z",
    fill: "#f08a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 38 L15 43 L15 45 L24 43 L33 45 L33 43 Z",
    fill: "#f08a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 3 C28 8 30 16 30 26 C30 36 28 43 24 46 C20 43 18 36 18 26 C18 16 20 8 24 3 Z",
    fill: "#f6a94a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17,
    r: 5.5,
    fill: "#fde3c0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier);
export default __webpack_public_path__ + "static/media/courier.a8e1e0a2b5fffbc38b9119b5c300f9b8.svg";
export { ForwardRef as ReactComponent };